import { observer } from 'mobx-react-lite';
import {
  TableManager,
  TableManagerProps,
  TableProps
} from '../../../../lib/components/compound/table';
import { ReceiptsViewModel } from '../../../../viewModels/receipts';
import { ReceiptsRowViewModel } from '../row/viewModel';
import { ReceiptsTableViewModel } from '../viewModel';
import { ReceiptAction } from '../../dialogs/action/viewModel';
import { ReceiptsTable } from '../component';

type Props = Omit<
  TableManagerProps<
    ReceiptsViewModel,
    ReceiptsRowViewModel,
    ReceiptsTableViewModel,
    TableProps<ReceiptsViewModel, ReceiptsRowViewModel, ReceiptsTableViewModel>
  >,
  'Table'
>;

export const ReceiptsTableManager = observer((props: Props) => {
  return (
    <TableManager
      Table={ReceiptsTable}
      {...props}
      openActionDialog={(action: ReceiptAction) => {
        props.viewModel.tableViewModel.actionDialog.open(props.viewModel.selectedItems, action);
      }}
    />
  );
});
